import { Badge } from '../ui/badge';
import { CheckCircle, X, Clock } from '@phosphor-icons/react';

/**
 * DocumentStatusBadge - Displays document validation status
 */
export const DocumentStatusBadge = ({ status }) => {
    const statusConfig = {
        pending: { label: 'Da verificare', variant: 'outline', className: 'border-amber-300 text-amber-700 bg-amber-50' },
        approvato: { label: 'Approvato', variant: 'outline', className: 'border-green-300 text-green-700 bg-green-50' },
        rifiutato: { label: 'Rifiutato', variant: 'outline', className: 'border-red-300 text-red-700 bg-red-50' }
    };
    const config = statusConfig[status] || statusConfig.pending;
    
    return (
        <Badge variant={config.variant} className={`text-xs ${config.className}`}>
            {status === 'approvato' && <CheckCircle weight="fill" className="w-3 h-3 mr-1" />}
            {status === 'rifiutato' && <X weight="bold" className="w-3 h-3 mr-1" />}
            {status === 'pending' && <Clock className="w-3 h-3 mr-1" />}
            {config.label}
        </Badge>
    );
};

export default DocumentStatusBadge;
